import Markdown from '@/components/markdown/markdown';
import { useEnterKeyGlobal } from '@/hooks/use-enter-key';
import { Box, Flex, Image, Text } from '@cmpsr/components';
import { FC } from 'react';
import { useInfoImageInterstitialController } from './InfoImageInterstitial.controller';
import { InfoImageInterstitialProps } from './types';

export const InfoImageInterstitial: FC<InfoImageInterstitialProps> = ({ data, saveAnswer, goToNextSurveyItem }) => {
  const { title, subtitle, text, imageId, handleNextClick } = useInfoImageInterstitialController({
    saveAnswer,
    data,
    goToNextSurveyItem,
  });

  useEnterKeyGlobal(handleNextClick);

  return (
    <Flex
      textAlign="center"
      pt={{ base: '6', lg: '16' }}
      alignSelf="stretch"
      gap={{ base: '6', md: '16' }}
      alignItems="center"
      justifyContent={{ lg: 'center' }}
      flexDirection={{ base: 'column', lg: 'row' }}
      flex="1"
      id="info-image-interstitial"
      minHeight="80vh"
      mb="64px"
    >
      <Flex flexDirection="column" alignItems={{ base: 'flex-start', md: 'center' }} justifyContent="center" gap="4">
        {title && (
          <Text variant="text-body-meta-medium" textTransform="uppercase" textAlign="left">
            <Markdown
              components={{
                p: ({ node, ...props }) => <Text variant="text-body-meta-medium" {...props} />,
                em: ({ node, ...props }) => (
                  <Text as="span" variant="text-body-meta-medium" color="salmon" {...props} />
                ),
              }}
            >
              {title}
            </Markdown>
          </Text>
        )}
        <Image
          src={`/images/info-interstitials/${imageId}.svg`}
          alt={title}
          w="100%"
          h="auto"
          overflow="hidden"
          objectFit="cover"
          objectPosition="center"
        />
      </Flex>
      <Flex
        textAlign="left"
        maxW={{ base: '450px', md: '600px' }}
        gap="4"
        flexDirection="column"
        alignItems="center"
        px={{ base: '12', md: '20', lg: '22', xl: '24', xxl: '32' }}
      >
        {subtitle && (
          <Text variant="text-body-regular" color="text-link-secondary-default">
            {subtitle}
          </Text>
        )}
        <Box>
          <Markdown
            components={{
              p: ({ node, ...props }) => <Text variant="text-body-meta-regular" color="text-secondary" {...props} />,
              br: () => <Box py="spacer-1" />,
            }}
          >
            {text}
          </Markdown>
        </Box>
      </Flex>
    </Flex>
  );
};
